import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { OPPORTUNITY_SOURCES, OPPORTUNITY_STAGES, OPPORTUNITY_STATUSES } from "@/api/types";
import { OpportunitiesPage } from "@/features/opportunities/opportunities-page";
import { baseListSearch, optionalDate, optionalEnum, optionalString } from "@/lib/list-state";

export const Route = createFileRoute("/_authenticated/opportunities/")({
  validateSearch: z.object({
    ...baseListSearch,
    organizationId: optionalString,
    storeId: optionalString,
    source: optionalEnum(OPPORTUNITY_SOURCES),
    stage: optionalEnum(OPPORTUNITY_STAGES),
    status: optionalEnum(OPPORTUNITY_STATUSES),
    assignedUserId: optionalString,
    createdFrom: optionalDate,
    createdTo: optionalDate,
  }),
  head: () => ({ meta: [{ title: "Opportunities · Rogue Admin" }] }),
  component: OpportunitiesPage,
});
